import Vue from 'vue';
import Vuetable from 'vuetable-2';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
Vue.component('vuetable', Vuetable);
Vue.component('vuetable-pagination', VuetablePagination);
